<template>
    <div class="main m-bottom-full">
        <section id="purchase-section">
            <div class="container">
                <div class="purchase-block">
                    <a :href="'/' + getPageSlugByLayout('specifications') + '/' + product.slug" class="btn btn-sm btn-primary mb-3">
                        <i class="bi bi-arrow-90deg-left"></i> Back To Product
                    </a>
                    <h3>Purchase Now: <span class="text-primary">{{ product.meta.title }} ({{ product.location_variants.find(i => i.id == variantSelected).name }})</span> | <span class="text-secondary">{{ (product.discounted_price ? product.discounted_price : product.price) | filterPrice }}</span></h3>

                    <div class="d-flex gap-2 mb-3">
                        <div class="form-check">
                            <input v-model="shippingMethod" class="form-check-input" type="radio" id="exampleRadios1" value="pick_up" checked>
                            <label class="form-check-label" for="exampleRadios1">
                                Pick Up
                            </label>
                        </div>
                        <div class="form-check">
                            <input v-model="shippingMethod" class="form-check-input" type="radio" id="exampleRadios2" value="domestic_shipping">
                            <label class="form-check-label" for="exampleRadios2">
                                Domestic Shipping <span class="text-primary">(+ {{ product.shipping_price | filterPrice }})</span>
                            </label>
                        </div>
                    </div>

                    <CheckoutContactInformation
                        :with-address="shippingMethod === 'domestic_shipping'"
                        :with-address2="shippingMethod !== 'domestic_shipping'"
                        ref="contactInformation"
                        :referrer="referrer"
                        :product-variant-selected="variantSelected ? variantSelected : ''"
                        :product-shipping-method="shippingMethod"
                        :product-shipping-address="shippingAddress"
                        :product="product"
                        :stripe-submit="stripeSubmit"
                        :is-product="true"
                        :disable-loader="stripeDisableLoader"
                    >
                    </CheckoutContactInformation>
                    <button class="btn btn-primary w-100 purchase-button" :class="{ disabled: loadingState }" @click="stripeSubmitAction">
                        {{ loadingState ? 'Loading...' : 'Purchase' }}
                    </button>
                </div>
            </div>
        </section>
        <div class="modal fade" id="modalCheckoutResult" tabindex="-1" aria-labelledby="modalCheckoutResultLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body p-5">
                        <h4 class="text-center my-3">Payment processing...</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FareHarborMixin from "../../mixins/FareHarborMixin";
import CheckoutContactInformation from "../components/blocks/checkout/CheckoutContactInformation";
import {mapActions, mapGetters} from "vuex";
import ApiRequest from "../../utils/api-request";
import LoaderMixin from "../../mixins/LoaderMixin";
import PageLayoutContentMixin from "../../mixins/ContentMixin";

export default {
    name: "ProductCheckout",
    mixins: [LoaderMixin, FareHarborMixin, PageLayoutContentMixin],
    components: {CheckoutContactInformation},
    data() {
        return {
            product: {},
            variantSelected: null,
            shippingMethod: 'pick_up',
            stripeSubmit: false,
        }
    },
    computed: {
        ...mapGetters('app', ['firstName', 'lastName', 'email', 'phone', 'address', 'address2']),
        ...mapGetters('cart', ['totalPrice', 'totalTax', 'totalDiscount']),
        ...mapGetters('payment', ['creditCard']),
        shippingAddress() {
            return 'Address 1: ' + this.address.firstLine + '; ' +
                'Address 2: ' + this.address.secondLine + '; ' +
                'City: ' + this.address.city + '; ' +
                'Country: ' + this.address.country + '; ' +
                'State: ' + this.address.state + '; ' +
                'Zip Code: ' + this.address.zipCode + ';'

        },
        referrer() {
            return document.querySelector('meta[name="ref"]')?.content ?? null;
        }
        // product() {
        //     return new URLSearchParams(window.location.search).get('product');
        // }
    },
    beforeMount() {
        if (this.fareHarborMode()) {
            window.location.href = '/';
        }
    },
    methods: {
        ...mapActions('payment', ['initCreditCardPayment']),
        stripeSubmitAction() {
            if (!this.$refs.contactInformation.validate()) {
                return;
            }
            this.enableLoader();

            this.stripeSubmit = true;
        },
        stripeDisableLoader() {
            this.stripeSubmit = false;
            this.disableLoader();
        },
        purchase() {
            if (!this.$refs.contactInformation.validate()) {
                return;
            }
            this.enableLoader();

            let payload = {
                debug: process.env.NODE_ENV === 'development',
                ref: this.referrer,
                account: this.creditCard.account.replace(/\s+/g, ''),
                expirationDate: this.creditCard.expirationYear + this.creditCard.expirationMonth,
                cvv2: this.creditCard.cvv,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                address: this.shippingMethod === 'domestic_shipping' ? this.address.firstLine : this.address2.firstLine,
                postalCode: this.shippingMethod === 'domestic_shipping' ? this.address.zipCode : this.address2.zipCode,
                discount_code: null,
                type: 'product',
                shipping_method: this.shippingMethod,
                data: JSON.stringify({
                    products: [
                        {
                            id: this.variantSelected,
                            qty: 1
                        }
                    ]
                })
            }

            if (this.shippingMethod === 'domestic_shipping') {
                payload = {
                    ...payload,
                    shipping_address: this.shippingAddress
                }
            }

            let modal = new bootstrap.Modal(document.getElementById('modalCheckoutResult'));
            modal.show();

            new ApiRequest().checkout(payload).then((response) => {
                if (!response.data.status) {
                    this.$notify({
                        text: response.data.message,
                        type: 'error'
                    });
                    return;
                }
                this.initCreditCardPayment();

                try {
                    gtag('event', 'conversion', {
                        'send_to': window.gtag_send_to,
                        'value': ((this.product.price) / 100),
                        'currency': 'USD',
                        'transaction_id': response.data.info.qr,
                        'ref': this.referrer
                    });
                } catch (e) {
                    console.log(e)
                }

                location.href = '/checkout-success/thank-you-purchase/' + btoa(JSON.stringify({data: response.data, product: this.product.meta.title}));
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: 'Server error!',
                    text: 'Something went wrong. Please contact our support service',
                    duration: 5000
                });
            }).finally(() => {
                this.disableLoader();
                modal.hide();
            });
        }
    },
    mounted() {
        this.variantSelected = this.$attrs.variant;
        new ApiRequest().getProductBySlug(this.$attrs.slug).then((response) => {
            this.product = response.data.product;
        })
    }
}
</script>

<style scoped>

</style>
